import { useState } from "react";
//ReactEcharts
import ReactEcharts from "echarts-for-react";

import PropTypes from "prop-types";

//redux
import { useSelector } from "react-redux";
//utils
import { AppendStatsToBarCharts } from "../../../utils/AppendStatsToCharts";

function HorizontalBarGraphs({ data = [], tTest = {}, productColors = {} }) {
    const { tTestResult } = tTest;
    const [productVisibility, setProductVisibility] = useState({});
    const isPercentage = useSelector((state) => state.analysisResultsStore.percentageToggle);
    const { _rich, seriesData } = AppendStatsToBarCharts(data, isPercentage, productColors, tTestResult, productVisibility);

    const labels = data.map((datum) => datum.title);
    const seriesBars = [
        {
            data: seriesData,
            type: "bar",
            barWidth: "80%",
            barGap: "-30%",
            barCategoryGap: "50%",
            emphasis: {
                itemStyle: {
                    shadowBlur: 20,
                    shadowOffsetX: 5,
                    shadowColor: "rgba(150, 150, 150, 0.7)",
                },
            },
        },
    ];

    const additionalLegends = labels.map((label) => ({
        name: label,
        type: "bar",
        data: [],
        itemStyle: {
            color: productColors[label.split(" ").join("_")],
        },
    }));

    const series = seriesBars.concat(additionalLegends);

    const handleLegendSelectChanged = (params) => {
        const productTitle = params.name;
        const titleArr = params.name.split(" - ");
        const isHidden = !params.selected[productTitle];
        const index = data.findIndex((product) => product.title === titleArr[0]);
        if (index !== -1) {
            const product = data.find((ele) => ele.title === titleArr[0]);
            const visibilityKey = `checked--${product.title.split("/").join("/").trim().split(" ").join("_")}__${product.coreDataId}`;
            // Update the productsVisibility store
            const updatedVisibility = {
                ...productVisibility,
                [visibilityKey]: isHidden,
            };
            setProductVisibility(updatedVisibility);
        }
    };

    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                const marker = (color) => `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:9px;height:9px;background:${color}"></span>`;
                const scoreVal = (val) => (isPercentage ? `${val}%` : val);
                const nameArr = params.data.details?.[0].name.split("/");
                const filteredTestResult = tTestResult?.[0]?.colors?.find((ele) => ele.productCode.toLowerCase() == nameArr[0].trim().toLowerCase()) || {};
                const testLabel = filteredTestResult?.label || "";
                let tooltipText = ``;
                if (params.data.details) {
                    tooltipText += params.data.details.map((detail) => `${marker(params.color)} <span style="font-weight: bold;">${detail.name}</span> : <span>${scoreVal(detail.value)}</span> <span style="font-weight: bold; margin-left: 4px;">${testLabel}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        grid: {
            left: "35%",
            top: "20%",
            right: "10%",
            bottom: "10%",
        },
        legend: {
            top: -5,
            type: "scroll",
            icon: "roundRect",
            itemGap: 16,
            left: "center",
            width: "90%",
            height: 50,
            orient: "horizontal",
            selectedMode: false,
            
        },
        xAxis: {
            type: "value",
        },
        yAxis: {
            type: "category",
            data: labels,
            axisLabel: {
                align: "right",
                width: 400,
                padding: [1, 5],
                fontFamily: "poppinsregular",
                formatter: function (value, index) {
                    return `{${index}| ${value}}`;
                },
                rich: _rich,
            },
        },
        series: series,
    };
    return (
        <div style={{ overflow: "auto" }}>
            <ReactEcharts
                option={option}
                style={{ minHeight: "450px", minWidth: "700px", maxHeight: "450px" }}
                opts={{ renderer: "svg" }}
                onEvents={{
                    legendSelectChanged: handleLegendSelectChanged,
                }}
            />
        </div>
    );
}

// Typechecking props for the HorizontalBarGraphs
HorizontalBarGraphs.propTypes = {
    data: PropTypes.array,
    tTest: PropTypes.object,
    productColors: PropTypes.object,
};

export default HorizontalBarGraphs;
